import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  Input,
  Select,
  Switch,
  Text,
  VStack,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import React, { useContext, useEffect, useState } from "react";
import { appRequest } from "routes";

const permissionsList = [
  {
    category: "Orders",
    permissions: [
      { value: "canViewOrderDashboard", label: "Order Dashboard" },
      { value: "canViewOrders", label: "Order Details" },
      // { value: "canCancelOrders", label: "Can Cancel Orders" },
      // { value: "canRaiseIssue", label: "Can Raise Issue" },
    ],
  },
  // {
  //   category: "Reconciliation",
  //   permissions: [
  //     {
  //       value: "canViewReconciliationDashboard",
  //       label: "Reconciliation Dashboard",
  //     },
  //     { value: "canViewReconciliation", label: "Reconciliation Details" },
  //   ],
  // },
  // {
  //   category: "Map",
  //   permissions: [
  //     { value: "canViewCities", label: "Cities" },
  //     { value: "canEditCities", label: "Can Edit Cities" },
  //     { value: "canViewProviders", label: "Providers" },
  //     { value: "canEditProviders", label: "Can Edit Providers" },
  //     { value: "canViewStations", label: "Stations" },
  //     { value: "canEditStations", label: "Can Edit Stations" },
  //   ],
  // },
  {
    category: "FAQs",
    permissions: [
      { value: "canViewFaqs", label: "FAQs" },
      { value: "canEditCategories", label: "Can Edit Categories" },
      { value: "canEditFaqs", label: "Can Edit FAQs" },
    ],
  },
  // {
  //   category: "Ad",
  //   permissions: [
  //     { value: "canViewAds", label: "Ads" },
  //     { value: "canEditAds", label: "Can Edit Ads" },
  //   ],
  // },
  // {
  //   category: "Payment",
  //   permissions: [
  //     { value: "canViewPayment", label: "Payment" },
  //   ],
  // },
  {
    category: "Issues",
    permissions: [
      { value: "canViewIssueDashboard", label: "Issue Dashboard" },
      { value: "canViewIssue", label: "Issue Details" },
      { value: "canUpdateIssue", label: "Issue Update" },

      // { value: "canRespondToIssue", label: "Can Respond To Issue" },
    ],
  },
  {
    category: "Sdk",
    permissions: [
      { value: "canViewSdkOrders", label: "Sdk Orders" },
    ],
  },
  {
    category: "Users",
    permissions: [
      { value: "canViewUsers", label: "Users" },
      // { value: "canRespondToIssue", label: "Can Respond To Issue" },
    ],
  },
  // {
  //   category: "Settings",
  //   permissions: [
  //     { value: "canCreateUser", label: "Can Create User" },
  //     { value: "canSeeBapIds", label: "Bap Ids" },
  //     { value: "canChangeStationStatus", label: "Change Station Status" },
  //   ],
  // },
  // Remaining permissions are directly shown without grouping
  // {
  //   category: "Direct",
  //   permissions: [
  //     // { value: "canCloseIssue", label: "Can Close Issue" },
  //     { value: "hasChatFeature", label: "HelpDesk Feature" },
  //   ],
  // },
];

type Permissions = {
  [key: string]: boolean;
};

export default function CreateUser({
  initialData,
  onSubmit,
  getUsers,
  setIsCreateModalOpen,
}: any): JSX.Element {
  const isEditMode = Boolean(
    initialData && Object.keys(initialData).length > 0
  );
  const [formData, setFormData] = useState<any>({
    name: "",
    username: "",
    password: "",
    moNumber: "",
    role: "user",
  });

  const [errors, setErrors] = useState<Record<string, string>>({});
  const { toastNotify } = useContext(AppContext);

  const [permissions, setPermissions] = useState<Permissions>(
    Object.fromEntries(
      permissionsList?.map((permission) => [permission, false])
    )
  );

  const [loading, setLoading] = useState(false);
  const [sdkTokens, setSdkTokens] = useState<any[]>([]);
  const [selectedSdkKey, setSelectedSdkKey] = useState<string>("");

  // useEffect(() => {
  //   if (initialData) {
  //     setFormData(initialData);
  //     const initialPermissions = Object.fromEntries(
  //       permissionsList?.map((permission: any) => [
  //         permission.value,
  //         initialData?.permission?.includes(permission.value),
  //       ])
  //     );
  //     setPermissions(initialPermissions);
  //   }
  // }, [initialData]);

  console.log("inisial data", initialData)

  const getSdkKeys = async () => {
    try {
      setLoading(true);
      const response: any = await appRequest("sdkToken", "getAll");
      console.log("get getAll sdk tokens response", response);
      if (response?.status === "success" && Array.isArray(response.sdkTokens)) {
        setSdkTokens(response.sdkTokens.filter((t: { isActive: any; }) => t.isActive));
      }
    } catch (error: any) {
      console.error("error in getting sdk data", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
      // Flatten the permissions list
      const flattenedPermissions = permissionsList.flatMap((group) =>
        group.permissions.map((permission) => permission.value)
      );

      // Initialize individual permissions state
      const initialPermissions = Object.fromEntries(
        flattenedPermissions.map((permission) => [
          permission,
          initialData?.permission?.includes(permission),
        ])
      );
      setPermissions(initialPermissions);

      // ✅ also set selected SDK key if present
      if (initialData.sdkKey) {
        setSelectedSdkKey(initialData.sdkKey);
      }

      // Initialize category states
      const initialCategoryState = Object.fromEntries(
        permissionsList.map((group) => [
          group.category,
          group.permissions.some((permission) =>
            initialData?.permission?.includes(permission.value)
          ), // Set category switch to on if any child permission is on
        ])
      );

      // setCategoryState(initialCategoryState);
    }
  }, [initialData]);

  useEffect(() => {
    getSdkKeys();
  }, []);

  const hasSdkPermission = permissionsList
    .find((g) => g.category === "Sdk")
    ?.permissions.some((p) => permissions[p.value]);

  const handlePermissionChange = (permission: string) => {
    setPermissions((prev) => ({ ...prev, [permission]: !prev[permission] }));
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};
    console.log("form data in validation", formData);
    console.log(
      "number length in validation",
      formData.moNumber.toString().length
    );

    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.username) {
      newErrors.username = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.username)) {
      newErrors.username = "Invalid email format";
    }
    if (!initialData) {
      if (!formData.password) newErrors.password = "Password is required";
      else if (formData.password.length < 6)
        newErrors.password = "Password must be at least8 characters";
    }
    if (!formData.moNumber || formData.moNumber.toString().length !== 10) {
      newErrors.moNumber = "MO Number should be 10 digits";
    }
    // if (!["user", "admin"].includes(formData.role)) {
    //   newErrors.role = 'Role must be "user" or "admin"';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // setFormData((prev:any)=>({...prev,role:"user"}))
    console.log("on submit ", formData);
    if (!validateForm()) return;
    const payload = {
      ...formData,
      role: "user",
      permission: Object.keys(permissions).filter(
        (permission) => permissions[permission]
      ),
      sdkKey: selectedSdkKey || null,
    };
    try {
      if (Object.keys(initialData).length === 0) {
        const response: any = await appRequest(
          "auth",
          "registerAdmin",
          payload
        );
        if (response.status === "success") {
          toastNotify({
            title: "Success",
            message: "User created successfully",
            type: "success",
          });
          getUsers();
          setIsCreateModalOpen(false);
        } else {
          toastNotify({
            title: "Error in creating User",
            message: response.message,
            type: "error",
          });
        }
      } else {
        await onSubmit(payload);
        // console.log("payload", payload)
      }
    } catch (error: any) {
      console.error("error in creating user", error.message);
    }
  };

  return (
    <Box mt={4}>
      <form onSubmit={handleSubmit}>
        <Grid
          gap={6}
          templateColumns={"1fr 1fr"}
          mb={8}
          p={5}
          shadow={"base"}
          rounded={"lg"}
          borderWidth={1}
        >
          <FormControl isInvalid={!!errors.name} variant={"floating"}>
            <Input
              id="name"
              name="name"
              placeholder=""
              value={formData.name}
              onChange={handleInputChange}
            />
            <FormLabel htmlFor="name">Name</FormLabel>
            <FormErrorMessage>{errors.name}</FormErrorMessage>
          </FormControl>
          <FormControl isInvalid={!!errors.username} variant={"floating"}>
            <Input
              id="username"
              name="username"
              type="email"
              placeholder=""
              value={formData.username}
              onChange={handleInputChange}
            />
            <FormLabel htmlFor="email">Email</FormLabel>
            <FormErrorMessage>{errors.username}</FormErrorMessage>
          </FormControl>
          {Object.keys(initialData).length === 0 && (
            <FormControl isInvalid={!!errors.password} variant={"floating"}>
              <Input
                id="password"
                name="password"
                type="password"
                placeholder=""
                value={formData.password}
                onChange={handleInputChange}
              />
              <FormLabel htmlFor="password">Password</FormLabel>
              <FormErrorMessage>{errors.password}</FormErrorMessage>
            </FormControl>
          )}
          <FormControl isInvalid={!!errors.moNumber} variant={"floating"}>
            <Input
              id="moNumber"
              name="moNumber"
              placeholder=""
              value={formData.moNumber}
              onChange={handleInputChange}
            />
            <FormLabel htmlFor="moNumber">Mobile Number</FormLabel>
            <FormErrorMessage>{errors.moNumber}</FormErrorMessage>
          </FormControl>
        </Grid>
        <Text fontSize="lg" fontWeight="bold">
          Permissions
        </Text>

        <VStack spacing={2} p={4} align={"stretch"}>
          {permissionsList
            ?.filter((group) => group.category !== "Direct")
            .map((group, index) => (
              <Box
                key={index}
                borderWidth={1}
                borderRadius="lg"
                p={4}
                mb={2}
                borderColor="gray.200"
                bg={"gray.100"}
              >
                <FormControl>
                  <FormLabel
                    htmlFor={group.category}
                    display="flex"
                    alignItems="center"
                    fontWeight="bold"
                    fontSize="lg"
                  >
                    <Text>{group.category}</Text>
                  </FormLabel>
                </FormControl>

                <Grid templateColumns={"1fr 1fr 1fr"} gap={2} mt={4}>
                  {group.permissions.map((permission) => (
                    <FormControl key={permission.value} mb={2}>
                      <FormLabel
                        htmlFor={permission?.value}
                        display="flex"
                        alignItems="center"
                      >
                        <Switch
                          id={permission.value}
                          isChecked={permissions[permission.value]}
                          onChange={() =>
                            handlePermissionChange(permission.value)
                          }
                          colorScheme="teal"
                        />
                        <Text ml={2}>{permission.label}</Text>
                      </FormLabel>
                    </FormControl>
                  ))}
                </Grid>

                {group.category === "Sdk" && hasSdkPermission && (
                  <FormControl variant={"floating"} mt={4}>
                    <Select
                      id="sdkKey"
                      placeholder=""
                      name="sdkKey"
                      size={{ base: "sm", md: "md" }}
                      variant="outline"
                      value={selectedSdkKey}
                      onChange={(e) => setSelectedSdkKey(e.target.value)}
                    >
                      <option value="">Select</option>
                      {sdkTokens.map((token) => (
                        <option key={token._id} value={token.sdkKey}>
                          {token.name}
                        </option>
                      ))}
                    </Select>
                    <FormLabel htmlFor="sdkKey">SDK Key (optional)</FormLabel>
                  </FormControl>
                )}

              </Box>
            ))}

          {/* <Grid
            templateColumns={"1fr 1fr"}
            borderWidth={1}
            borderRadius="lg"
            p={4}
            borderColor="gray.200"
            bg={"gray.100"}
          >
            {permissionsList
              .find((group) => group.category === "Direct")
              ?.permissions.map((permission) => (
                <FormControl key={permission.value}>
                  <FormLabel
                    htmlFor={permission?.value}
                    display="flex"
                    alignItems="center"
                  >
                    <Switch
                      id={permission.value}
                      isChecked={permissions[permission.value]}
                      onChange={() => handlePermissionChange(permission.value)}
                      colorScheme="teal"
                    />
                    <Text ml={2}>{permission.label}</Text>
                  </FormLabel>
                </FormControl>
              ))}
          </Grid> */}
        </VStack>

        <Flex justify={"end"}>
          <Button type="submit" colorScheme="teal">
            Submit
          </Button>
        </Flex>
      </form>
    </Box>
  );
}
